// Enshrine.js
import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom"; // 추가
import { useAuth } from "../AuthContext";
import "../styles/Enshrine.css";
import { FaEdit } from "react-icons/fa"; // 수정 아이콘 추가
//import EnshrineRegisterModal from "./EnshrineRegisterModal";
//import EnshrineEditModal from "./EnshrineEditModal";
import AddLog from "./AddLog"; // ✅ 로그 저장 함수 가져오기

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const Enshrine = () => {
    const navigate = useNavigate(); // 페이지 이동을 위한 훅

    const { user /*, setUser */} = useAuth();
    const [users, setUsers] = useState([]);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const pageSize = 10;
    //const [isModalOpen, setIsModalOpen] = useState(false); // 모달 상태 관리
    const [searchField, setSearchField] = useState(user.userType === "P" ? "deceasedName" : "all");  // 라디오 버튼에서 선택된 항목
    const [searchKeyword, setSearchKeyword] = useState(null);  // 검색 키워드
    const [selectedEnshrine, setSelectedEnshrine] = useState(null);

    const [ClickOrEdit, setClickOrEdit] = useState(false);

    const [plist, setPlist] = useState([]);
    const [glist, setGlist] = useState([]);
    const [LoginUserText, setLoginUserText] = useState("");

    
    const hasRun = useRef(false);

    const LogInsert3_3 = async () => {
        await AddLog(user.userId, "", selectedEnshrine.enshrineCode, "3-3");
    }

    useEffect(() => {
        if (searchField !== null && searchKeyword === null) {
            setSearchKeyword("");
        }
    }, [searchField]);

    useEffect(() => {       
        if (!user.userType) {
            navigate("/login");
        }
    }, []); // 페이지 로드 시 실행
    
    useEffect(() => {
        window.onload = function () {
            setTimeout(() => {
                window.history.scrollRestoration = "manual"; // 이전 스크롤 위치 기억 방지
                window.scrollTo(0, 0);
            }, 100); // 100ms 후 실행 (브라우저마다 조정 가능)
        };       
    }, []); // 페이지 로드 시 실행

    useEffect(() => {
        if (selectedEnshrine) {
            if (ClickOrEdit) {
                LogInsert3_3();
                navigate("/enshrineview", { state: { enshrine: selectedEnshrine } });
            }
            else {
                navigate("/enshrineedit", { state: { enshrine: selectedEnshrine, PList: plist, GList: glist } });
            }
        }
        //console.log("1몇번실행될지????");
    }, [selectedEnshrine, navigate]);

    useEffect(() => {
        fetchUsers(searchField, searchKeyword);
        //console.log("2몇번실행될지????");
    }, [page]);

    useEffect(() => {
        const validTotalPages = totalPages > 0 ? totalPages : 1; // totalPages가 0 또는 null이면 1로 설정

        if (page > validTotalPages) {
            setPage(validTotalPages);  // 현재 선택된 페이지가 전체 페이지보다 크면 마지막 페이지로 이동
        }
    }, [totalPages]);  // totalPages가 변경될 때 실행


    useEffect(() => {
        if (hasRun.current) return; // 이미 실행되었으면 종료
        hasRun.current = true; // 첫 실행 후 플래그 설정

        //setUser();
        if (user.userType) {
            getPartnerCode();
            getGovernmentCode();
        }
        
        
        
    }, []);

    useEffect(() => {
        if (user.userType === "S") {

            setLoginUserText(`Admin > ${user.name}`);
        }
        else if (user.userType === "P" && plist.length > 0) {
            const selectedPartner = plist.find(p => p.partnerCode === user.partnerCode);
            const partnerName = selectedPartner?.partnerName ?? "알 수 없는 파트너";
            setLoginUserText(`${partnerName} > ${user.name}`);
        }
        else if (user.userType === "G" && glist.length > 0) {
            const selectedGovernment = glist.find(p => p.governmentCode === user.governmentCode);
            const governmentName = selectedGovernment?.governmentName ?? "알 수 없는 파트너";
            setLoginUserText(`${governmentName} > ${user.name}`);
        }
        else if (user.userType === "U") {

            setLoginUserText(`${user.userId}`);
        }
        else {
            setLoginUserText(`비 정상 로그인입니다.`);
        }
    }, [plist, glist]); // plist가 업데이트될 때 실행

    

    const handleRowClick = (Enshrine) => {
        setClickOrEdit(true);
        setSelectedEnshrine(Enshrine);
        //console.log("Selected Enshrine:", Enshrine);

    };

    
    const handleEditClick = (Enshrine) => {
        setClickOrEdit(false);
        setSelectedEnshrine(Enshrine);
        //console.log("Selected Edit Enshrine:", Enshrine);
    };

    /*
    const handleSaveEnshrine = (updatedEnshrine) => {
        setUsers(users.map((u) => (u.snum === updatedEnshrine.snum ? updatedEnshrine : u)));
    };
    */

    const handleSearch = () => {
        fetchUsers(searchField, searchKeyword);  // 필터링된 값으로 다시 fetch 호출
    };

    const handleSearchFieldChange = (e) => {
        const selectedValue = e.target.value;
        setSearchField(e.target.value);  // 선택된 콤보박스 값 설정
        // "회원구분"을 선택하면 기본값 설정
        if (selectedValue === "enshrineType") {
            setSearchKeyword("A"); // 기본값을 "S"로 설정 (빛담관리자)
        } else {
            setSearchKeyword(""); // 다른 경우 입력값 초기화
        }
    };

    const handleSearchKeywordChange = (e) => {
        setSearchKeyword(e.target.value);  // 검색어 값 설정
    };

    const handleUserTypeChange = (e) => {
        setSearchKeyword(e.target.value); // 선택한 값(S, P, G, U) 저장
    };
    
    // 기존의 fetchUsers 함수에 검색 필터 추가
    const fetchUsers = async (searchField, searchKeyword) => {

        // ✅ 조건 차단
        if (searchField === "enshrineCode" && searchKeyword === "") {
            alert("봉안 고유번호를 입력해주세요");
            return; // ❗ fetch 중단
        }
        if (searchField === "enshrineDate" && searchKeyword === "") {
            alert("봉안일자 입력해주세요");
            return; // ❗ fetch 중단
        }
        if (searchField === "deceasedName" && searchKeyword === "") {
            alert("고인의 성명을 입력해주세요");
            return; // ❗ fetch 중단
        }

        if (searchField === "bereavedInfo" && searchKeyword === "") {
            alert("유가족 성명 또는 정보를 입력해주세요");
            return; // ❗ fetch 중단
        }
        if (searchField === "bereavedIDs" && searchKeyword === "") {
            alert("봉안 소유 유가족ID를 입력해주세요");
            return; // ❗ fetch 중단
        }
        if (searchField === "enshrineMemo" && searchKeyword === "") {
            alert("메모내용을 입력해주세요");
            return; // ❗ fetch 중단
        }


        try {
            if (user.userType) {
                const queryParams = new URLSearchParams({
                    page,
                    pageSize,
                    searchField,
                    searchKeyword,
                    loginPartner: user.partnerCode,
                    loginUserID: user.userId,
                    ...(user.userType ? { loginUserType: user.userType } : {})
                });

                const response = await fetch(`${API_BASE_URL}/api/Enshrine/get-enshrine?${queryParams}`);
                const data = await response.json();

                if (response.ok) {
                    setUsers(data.users);
                    //console.log(data);
                    setTotalPages(Math.ceil(data.totalRecords / pageSize));
                } else {
                    console.log(data.message || "조회 실패");
                }
            }
        } catch (error) {
            console.error("조회 실패:", error);
            alert("서버 오류 발생");
        }
    };

    
    /*
    // ✅ 사용자 추가 후 호출될 콜백 함수
    const handleEnshrineAdded = () => {
        setSearchField("");
        setSearchKeyword("");
        fetchUsers(searchField, searchKeyword);  // 사용자 추가 후 다시 목록 로드
    };

    const handleAddUserClick = () => {
        
        setIsModalOpen(true); // 팝업 열기
    };

    const closePopup = () => {
        setIsModalOpen(false); // 팝업 닫기
    };
    */

    const renderPagination = () => {
        if (totalPages <= 10) {
            return [...Array(totalPages)].map((_, index) => (
                <button
                    key={index + 1}
                    className={page === index + 1 ? "active" : ""}
                    onClick={() => setPage(index + 1)}
                >
                    [{index + 1}]
                </button>
            ));
        }
        let pages = [];
        if (page <= 6) {
            pages = [1, 2, 3, 4, 5, 6, 7, 8, 9, "...", totalPages];
        } else if (page >= totalPages - 5) {
            pages = [1, "...", totalPages - 8, totalPages - 7, totalPages - 6, totalPages - 5, totalPages - 4, totalPages - 3, totalPages - 2, totalPages - 1, totalPages];
        } else {
            pages = [1, "...", page - 3, page - 2, page - 1, page, page + 1, page + 2, page + 3, "...", totalPages];
        }

        return pages.map((p, index) => (
            <button
                key={index}
                className={page === p ? "active" : ""}
                onClick={() => typeof p === "number" && setPage(p)}
                disabled={typeof p !== "number"}
            >
                [{p}]
            </button>
        ));
    };


    // 파트너 코드 리스트 가져오기
    const getPartnerCode = async () => {

        try {
            const response = await fetch(`${API_BASE_URL}/api/Partner/get-list`);
            const data = await response.json();

            if (response.ok) {
                setPlist(data.plist);
                //console.log(data.plist);
            } else {
                alert(data.message || "조회 실패");
            }

        } catch (error) {
            alert("파트너 리스트 조회 중 오류가 발생했습니다.");
        }
    };

    // 파트너 코드 리스트 가져오기
    const getGovernmentCode = async () => {

        try {
            const response = await fetch(`${API_BASE_URL}/api/Government/get-list`);
            const data = await response.json();

            if (response.ok) {
                setGlist(data.glist);
                //console.log(data.glist);
            } else {
                alert(data.message || "조회 실패");
            }

        } catch (error) {
            alert("관공서 리스트 조회 중 오류가 발생했습니다.");
        }
    };



    return (
        <div className="enshrine-wrapper">
            <div className="enshrine-header">
                {/* <h1>봉안관리</h1> */}
                <h1>봉안관리 <span style={{ fontSize: "0.7em", color: "gray" }}>{LoginUserText}</span></h1>
                {(user.userType === "P" || user.userType === "S") && (
                    <button className="add-button" onClick={() => navigate("/enshrineadd", { state: { PList: plist, GList: glist }}  )}>+</button>                    
                )}
                {/*<button className="add-button" onClick={handleAddUserClick}>+</button>  + 버튼 */}
            </div>
            <hr className="title-line" />



            {/* ✅ 모달 창 표시 (EnshrineRegisterModal.js에 handleUserAdded 전달) 
            {isModalOpen && <EnshrineRegisterModal onClose={() => setIsModalOpen(false)} onEnshrineAdded={handleEnshrineAdded} />}
            */}


            {/* 검색 섹션 */}
            {user.userType !== "U" &&
                <div className="search-container">
                    <label>
                        <select value={searchField} onChange={handleSearchFieldChange}>
                            <option value="all">전체조회</option>
                            <option value="enshrineCode">고유번호</option>
                            <option value="enshrineType">봉안유형</option>
                            <option value="enshrineDate">봉안일자</option>
                            <option value="deceasedName">고인성명</option>
                            <option value="bereavedInfo">유가족정보</option>
                            <option value="bereavedIDs">유가족ID</option>
                            <option value="enshrineMemo">메모</option>
                            {user.userType === "S" && <option value="partnerCode">파트너코드</option>}
                            {user.userType === "S" && <option value="governmentCode">관공서코드</option>}
                        </select>
                    </label>

                    {/* 검색어 입력 (전체조회) */}
                    {searchField !== "all" && searchField !== "enshrineType" && searchField !== "partnerCode" && searchField !== "governmentCode" && (
                        <label>

                            <input
                                type="text"
                                value={searchKeyword}
                                onChange={handleSearchKeywordChange}
                                maxLength={18}
                                onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                        handleSearch(); // 
                                    }
                                }}
                            />
                        </label>
                    )}
                    {/* "회원구분" 선택 시 새로운 콤보박스 출력 */}
                    {searchField === "enshrineType" && (
                        <label>
                            <select value={searchKeyword} onChange={handleUserTypeChange}>
                                <option value="A">무연고묘 봉안</option>
                                <option value="B">무연고묘 확인</option>
                                <option value="C">연고자 바로봉안</option>
                                <option value="D">연고자묘의 봉안</option>
                                <option value="E">연고자묘</option>
                            </select>
                        </label>
                    )}
                    {searchField === "partnerCode" && (
                        <label>
                            <select value={searchKeyword} onChange={handleUserTypeChange}>
                                <option value="">선택된 파트너 없음</option> {/* 기본값 */}
                                {plist.map((partner) => (
                                    <option key={partner.snum} value={partner.partnerCode}>
                                        {partner.snum}, {partner.partnerCode} : {partner.partnerName}
                                    </option>
                                ))}
                            </select>
                        </label>
                    )}
                    {searchField === "governmentCode" && (
                        <label>
                            <select value={searchKeyword} onChange={handleUserTypeChange}>
                                <option value="">선택된 관공서 없음</option> {/* 기본값 */}
                                {glist.map((government) => (
                                    <option key={government.snum} value={government.governmentCode}>
                                        {government.snum}, {government.governmentCode} : {government.governmentName}
                                    </option>
                                ))}
                            </select>
                        </label>
                    )}

                    <button onClick={handleSearch}>검색</button>
                </div>
            }

            <div className="enshrine-container">
                <ul className="enshrine-list">
                    <li className="enshrine-header-row">
                        {user.userType !== "U" && <span className="enshrineCode">고유번호</span>}
                        {user.userType === "U" && <span className="ppicture">영정사진</span>}
                        {user.userType !== "U" && <span className="enshrineType">봉안유형</span>}
                        {user.userType !== "U" && <span className="enshrineDate">봉안일자</span>}
                        <span className="deceasedName">고인성명</span>
                        {user.userType === "U" && <span className="enshrineDate">출생일</span>}
                        {user.userType === "U" && <span className="enshrineDate">사망일</span>}
                        {user.userType !== "U" && <span className="bereavedIDs">유가족ID</span>}
                        {user.userType === "S" && <span className="partnerCode">파트너코드</span>}
                        {user.userType === "S" && <span className="governmentCode">관공서코드</span>}
                        {user.userType === "U" && <span className="memo">유가족정보</span>}
                        {user.userType !== "S" && <span className="memo">메모</span>}
                        <span className="edititem">수정</span>

                    </li>

                    <hr className={user.userType === "U" ? "thick-line1" : "thick-line2"} />


                    {users.map((Enshrine, index) => (
                        <React.Fragment key={Enshrine.snum}>
                            <li
                                className="enshrine-row"
                                onClick={(event) => {
                                    // FaEdit을 클릭한 경우 handleRowClick 실행 안 함
                                    if (!event.target.closest(".edit-icon")) {
                                        handleRowClick(Enshrine);
                                    }
                                }}
                            >
                                {user.userType !== "U" && <span className="enshrineCode">{Enshrine.enshrineCode}</span>}
                                {user.userType === "U" && <span className="ppicture">
                                    <img src={`https://bitdamstorage.blob.core.windows.net/bitdamstorage/${Enshrine.enshrineCode}/C/${Enshrine.ppictureURL.replace(/(.*)\.(.*)/, "$1_T.$2")}`} alt="Preview"
                                        onError={(e) => {
                                            e.currentTarget.onerror = null;
                                            e.currentTarget.src =
                                                "https://bitdamstorage.blob.core.windows.net/bitdamstorage/flower.jpg";
                                        }}
                                    />
                                    
                                </span>}

                                {user.userType !== "U" && <span className="enshrineType">
                                    {{
                                        "A": "무연고묘 봉안",
                                        "B": "무연고묘 확인",
                                        "C": "연고자 바로봉안",
                                        "D": "연고자묘의 봉안",
                                        "E": "연고자묘"
                                    }[Enshrine.enshrineType] || "알 수 없음"}
                                </span>}
                                {user.userType !== "U" && <span className="enshrineDate">{Enshrine.enshrineDate}</span>}
                                <span className="deceasedName">{Enshrine.deceasedName}</span>
                                {user.userType === "U" && <span className="enshrineDate">{Enshrine.deceasedBDate}</span>}
                                {user.userType === "U" && <span className="enshrineDate">{Enshrine.deceasedDDate}</span>}
                                {user.userType !== "U" && <span className="bereavedIDs">{Enshrine.bereavedIDs}</span>}


                                {user.userType === "S" && <span className="partnerCode">
                                    {/* {Enshrine.partnerCode} */}
                                    {plist.find(partner => partner.partnerCode === Enshrine.partnerCode)?.partnerName || ''} 
                                </span>}
                                {user.userType === "S" && <span className="governmentCode">
                                    {/*  {Enshrine.governmentCode}  */}
                                    {glist.find(government => government.governmentCode === Enshrine.governmentCode)?.governmentName || ''} 
                                </span>}


                                {user.userType === "U" && <span className="memo">{Enshrine.bereavedInfo}</span>}
                                {user.userType !== "S" && <span className="memo">{Enshrine.deceasedMemo}</span>}
                                <span className="edititem">
                                    <FaEdit
                                        className="edit-icon"
                                        onClick={(event) => {
                                            
                                            handleEditClick(Enshrine);                                            
                                        }}
                                    />
                                </span>
                            </li>
                            <hr className="thin-line" />
                        </React.Fragment>
                    ))}

                    {/*
                    {selectedEnshrine && (
                        navigate("/enshrineview", { state: { enshrine: selectedEnshrine } })
                    )}
                    */}

                    <hr className="thick-line2" />
                </ul>
                <div className="pagination">{renderPagination()}</div>
            </div>




        </div>
    );

};

export default Enshrine;